export default "__VITE_ASSET__bFMARxQ3__"